<h2 mat-dialog-title><div translate class="failedHeader">PROCESS FAILED</div></h2>
<mat-dialog-content class="internetModal">
  <div translate>We were unable to contact the server to complete this process.</div>
  <div translate>This may be because your internet connection was interrupted or there may be a problem with the server.</div>
  <div translate *ngIf="!connectionRestored">When the connection is reestablished this message will change.</div>
  <ng-container *ngIf="connectionRestored">
    <div translate class="restoredHeader">CONNECTION RESTORED</div>
    <div translate>The connection has been reestablished</div>
    <div translate>You may encounter strange behavior within the program as a result of the connection loss.  If so, <br />
      logging out and back in should get things back to normal.
    </div>
    <div translate>Do you want to log out and back in now?</div>
  </ng-container>
  <br/>
</mat-dialog-content>
<mat-progress-bar *ngIf="!connectionRestored" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button *ngIf="!connectionRestored" image="cancel.png" label="Abort" (clickEvent)="closeClick()"></tyl-button>
    <tyl-button *ngIf="connectionRestored" image="save.png" label="Yes" (clickEvent)="logOutClick()"></tyl-button>
    <tyl-button *ngIf="connectionRestored" image="cancel.png" label="No" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>